export default "__VITE_ASSET__CU9FAl7f__"